import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { accountProductRoleSchema } from '../schemas/account-product-role.schema';

/**
 * Get all users for a product and account relationship
 * @param product Trimble Maps product name
 * @param accountId Id of the account
 * @returns Array of all users for a product and account relationship
 */
export function getProductAccountUsers(
  this: unknown,
  product: string,
  accountId: number
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}/users`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(accountProductRoleSchema)));
}
